import { all } from 'redux-saga/effects';
import buttonRequestSagas from './pages/Contact/sagas';
import reimbursementSagas from './pages/Reimbursement/sagas';
import troubleshootingGuideSagas from './pages/TroubleshootingGuide/sagas';

export default function* rootSagas() {
  yield all([...buttonRequestSagas, ...reimbursementSagas, ...troubleshootingGuideSagas]);
}
